
































































import { Component, Mixins, Prop, Vue, Watch } from 'vue-property-decorator';
import { boolean } from 'yup';
@Component
export default class ExportMenu extends Vue {
  menu: boolean = false;
  tooltipActivator: boolean = false;
  @Prop() type: string;
  mousePointAlert: boolean = false;
  @Watch('menu')
  onMenuChanged(value: string, oldValue: string) {
    if (value == 'true') {
      this.tooltipActivator = true;
    } else {
      this.tooltipActivator = false;
    }
  }

  point() {
    this.$emit('point', true);
  }

  exportCsv() {
    this.menu = false;
    this.$emit('exportData', this.type, 'csv');
    this.tooltipActivator = false;
  }
  exportExcel() {
    this.menu = false;
    this.$emit('exportData', this.type, 'xlsx');
    this.tooltipActivator = true;
  }
  exportJson() {
    this.menu = false;
    this.$emit('exportData', this.type, 'json');
    this.tooltipActivator = true;
  }
  activator() {
    return this.tooltipActivator;
  }
}
